import React from "react";
import Avatar from "antd/lib/avatar";
import Button from "antd/lib/button";
import "./concept.css";

const Concept = () => {
  return (
    <div style={{ marginBottom: "15px" }}>
      <p> Peers have three states: </p>

      <div 
        className="avatars"
        style={{ paddingBottom: "20px" }}
      >
        <div className="avatar-container">
          <Avatar
            className="blue"
            size="large"
            icon="user"
          />
          <div className="tag-style"> Currently Active </div>
        </div>
        
        <div className="avatar-container">
          <Avatar
            className="green"
            size="large"
            icon="user"
          />

          <div className="tag-style"> Connected </div>
        </div>
        
        <div className="avatar-container">
          <Avatar
            className="red"
            size="large"
            icon="user"
          />

          <div className="tag-style"> Disconnected </div>
        </div>
      </div>
      <p className="paragraph"> <b><b>To change peer:</b></b> Click on the desired peer. </p>
      <p className="paragraph"> <b><b>To connect to a peer:</b></b> On a red peer, click <Button size="small" shape="circle" icon="usergroup-add" />. </p>
      <p className="paragraph"> <b><b>To see history between peer:</b></b> On a green peer, click <Button size="small" shape="circle" icon="message" />. </p>
      <p className="paragraph"> <b><b>To disconnect with peer:</b></b> On a green peer, click <Button size="small" shape="circle" icon="usergroup-delete" />. </p>
    </div>
  );
};

export default Concept;



// WEBPACK FOOTER //
// ./src/steps/status-peer/concept.js